/**
 * Smooth-scroll in-page anchors (split hero CTAs and any other #section-id link).
 */
(function () {
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var frame = 0;

  function prefersReducedMotion() {
    return reduceQuery.matches;
  }

  function normalizePath(path) {
    if (!path) return '/';
    if (path.length > 1 && path.charAt(path.length - 1) === '/') {
      return path.slice(0, -1);
    }
    return path;
  }

  function headerOffset() {
    var shell = document.querySelector('.vg-header--sticky .vg-header__shell');
    if (!shell) return 16;
    var bottom = shell.getBoundingClientRect().bottom;
    if (bottom <= 0) return 16;
    return bottom + 12;
  }

  function cancelScroll() {
    if (frame) {
      window.cancelAnimationFrame(frame);
      frame = 0;
    }
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var top = window.pageYOffset + target.getBoundingClientRect().top - headerOffset();
    if (top < 0) top = 0;

    if (prefersReducedMotion()) {
      window.scrollTo(0, top);
      return;
    }

    var start = window.pageYOffset;
    var change = top - start;
    var duration = Math.min(1200, Math.max(480, Math.abs(change) * 0.5));
    var startTime = 0;

    cancelScroll();

    function ease(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function step(now) {
      if (!startTime) startTime = now;
      var progress = Math.min(1, (now - startTime) / duration);
      window.scrollTo(0, start + change * ease(progress));
      if (progress < 1) {
        frame = window.requestAnimationFrame(step);
      } else {
        frame = 0;
      }
    }

    frame = window.requestAnimationFrame(step);
  }

  function scrollToHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      return;
    }
    var target = document.getElementById(id);
    if (target) smoothScrollTo(target);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || (link.target && link.target !== '_self')) return;

    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (!url.hash || url.hash === '#') return;
    if (url.origin !== window.location.origin) return;
    if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) return;

    var id;
    try {
      id = decodeURIComponent(url.hash.slice(1));
    } catch (error) {
      return;
    }

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    smoothScrollTo(target);
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + id);
    }
  });

  window.addEventListener('wheel', cancelScroll, { passive: true });
  window.addEventListener('touchmove', cancelScroll, { passive: true });
  window.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'PageDown' || event.key === 'PageUp' || event.key === 'Home' || event.key === 'End' || event.key === ' ') {
      cancelScroll();
    }
  });

  window.addEventListener('load', function () {
    window.requestAnimationFrame(scrollToHash);
  });
})();
